import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchCategoriesForSelect, useCategoriesForSelect} from "../../../../redux/categories";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, isLoading, metadata} = useCategoriesForSelect()

  const handleSearch = search => {
    dispatch(
      fetchCategoriesForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name="category"
      label={'CATEGORY'}
      options={data}
      getOptionLabel={option=>option[localField()]}
      onOpen={()=>{
        handleSearch('')
      }}
      onInputChange={(event, search) => {
        handleSearch(search)
      }}
      loading={isLoading}
      {...props}
    />
  )
}